import { screenSizes } from '@lux/tokens';

export const isXsScreen = (w?: number): boolean => !!w && w < screenSizes.xs;
export const isSmScreen = (w?: number): boolean => !!w && w < screenSizes.sm;
export const isMdScreen = (w?: number): boolean => !!w && w < screenSizes.md;
export const isLgScreen = (w?: number): boolean => !!w && w >= screenSizes.md;
